export const HEADER_HEIGHT = 56;

export const TOP_PANEL_HEIGHT = 52;

export const FOOTER_HEIGHT = 56;

export const INPUT_HEIGHT = 48;

export const EMPTY_PLACEHOLDER = '–';
